<template>
<div id="InThailand" class="">
  <b-container fluid>
    <b-row>
      <!-- <b-col md="4" class="text-white bg-dark">2 of 2</b-col> -->
      <b-col md="10" class="form-login mx-auto mb-3">
        <b-card class="mb-1 animate__animated animate__fadeIn" footer-class="text-center" body-class="p-2">
          <b-card-body class="text-center align-items-center">
            <b>ข้อมูลสมาชิก [ {{ userData.userCode }} ] {{ userData.displayName }}</b>
            <br />
            <hr />
            <h5>รายการรหัสพัสดุเข้าไทยแล้ว</h5>
            <b-table striped bordered fixed
              :items="items" :fields="fields"
              show-empty
              empty-text="ไม่พบข้อมูล"
              class="table-mini"
              >

              <template #cell(details)="data">
                  รหัสสมาชิก :	{{ data.item.userCode }} <br>
                  รหัสพัสดุ :	{{ data.item.suppliesCode }} <br>
                  วลีช่วยจำ :	{{ data.item.mnemonicPhrase }} <br>
                  หมายเหตุ : {{ data.item.remark }}
              </template>


              <template #cell(transport)="data">
                  เข้าโกดัง :	<b>{{ formatDate(data.item.InWarehouse) }}</b> <br>
                  ออกโกดัง :	<b>{{ formatDate(data.item.OutWarehouse) }}</b> <br>
                  ถึงไทย :	<b>{{ formatDate(data.item.InThailand) }}</b> <br>
                  <!-- <template v-if="data.item.deliverDoc">
                    <hr>
                    รหัสใบชำระสินค้า : <router-link :to="{ path: 'Delivery', query: { Doc : data.item.deliverDoc }}">{{ data.item.deliverDoc }}</router-link> <i style="font-size: 0.5rem;">(กำลังรอตรวจสอบ)</i>
                  </template> -->
              </template>
            </b-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import axios from 'axios' // api
export default {
  name: 'InThailand',
  beforeCreate () {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    this.$liff.init({ liffId: '1656919687-L62D1DJ0' }, function (data) {})
    // document.body.className = 'login';
  },
  created () {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
  },
  async mounted () {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    // this.$session.destroy()

    await this.$liff.ready.then(async () => {
      if (process.env.NODE_ENV === 'development') {

      } else {
        if (!this.$liff.isLoggedIn()) {
          this.$liff.login({ redirectUri: window.location })
        } else {
          await this.getLineProfile()
        }
      }
    })

    // if (!this.$liff.isLoggedIn()) {
    //   this.$liff.login({ redirectUri: window.location })
    // } else {

    // }

    // localStorage.removeItem('memberData')
    // await this.getDataUser("tester")
  },
  data () {
    return {
      msg: 'Welcome Kathin',
      dataReady: true,
      fields: [
        { key: 'details', label: 'รายละเอียดพัสดุ', thClass: 'py-2' },
        { key: 'transport', label: 'รายละเอียดขนส่ง', thClass: 'py-2' },
      ],
      items: [
      ],
      profile: {
        userId: "",
        displayName: "กำลังดึงข้อมูล",
        pictureUrl: "https://rodpremium.com/assets/loader.gif"
      },
      userData: {
        userName: '',
        userCode: '',
        displayName: '',
        userLineId: ''
      },
      form: {
        userName: '',
        password: ''
      }
    }
  },
  methods: {
    async getLineProfile () {
      let _this = this
      await this.$liff.getProfile().then(async (profileLine) => {
        // console.log(profileLine)
        _this.profile = profileLine
        this.getLineLogin(profileLine)
      })
      .catch((err) => {
        console.log('Getting profile error:', err);
      })
    },
    formatDate (dtDate) {
      if (dtDate) {
        var strDateShort = dtDate.split('-')[2] + '/' + dtDate.split('-')[1] + '/' + dtDate.split('-')[0].substring(2, 4)
        return strDateShort
      } else {
        return ''
      }
    },
    getLineLogin (profileLine) {
      this.userData.userLineId = profileLine.userId
      this.dataReady = false
      axios
        .get(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Sys_line/profile?userLineId="+profileLine.userId,
          {
            headers: this.getHeaderAPI('Profile', profileLine.userId)
          }
        )
        .then((response) => {
          let rs = response.data
          if (rs.status === true){
            this.userData = rs.info
            this.dataReady = true
            this.getDataTracking()
          } else {
            // this.$swal("ผิดพลาด", "ไม่สามารถดึงข้อมูลส่วนตัวได้", "error")
            this.$router.push('/oa/login')
            this.dataReady = true
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log("ผิดพลาด","ไม่สามารถดึงข้อมูลส่วนตัวเพื่อหาเลขพัสดุได้", error)
          this.$swal("เกิดปัญหา", "ไม่สามารถดึงข้อมูลส่วนตัวเพื่อหาเลขพัสดุได้", "error")
          this.dataReady = true
          // this.errored = true
        })
    },
    getDataTracking () {
      this.dataReady = false;
      this.items = [];

      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Invoice_order/Invoice_export?userName=' +
          this.userData.userName +
          '&userType=U&userCode=' +
          this.userData.userCode +
          '&searchInThai=Y',
          {
            headers: this.getHeaderAPI('Invoice_export', this.userData.userName)
          }
        )
        .then((response) => {
          let rs = response.data
          if (rs.status === true){
            if (rs.data.length > 0) {
              this.items = rs.data
            } else {
              this.items = []
            }
          } else {
            this.items = []
          }

          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataTracking error:', error)
          this.dataReady = true
          this.items = []
        });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-login{
  margin-top: 2rem;
}
label{
  font-weight: 600;
}
.table-mini{
  padding: 0.5rem;
  font-size: 0.75rem;
  word-break: break-all;
}

.bg-licm{
  background-color: #edaf00!important;
}
</style>



// WEBPACK FOOTER //
// src/components/LineOA/LineInThailand.vue